/**
 * Оптимизированные импорты Ant Design компонентов
 * Используйте эти импорты вместо прямых импортов из 'antd'
 * для лучшей производительности и tree shaking
 */

// Иконки
export {
  AimOutlined,
  ApartmentOutlined,
  ApiOutlined,
  AppstoreAddOutlined,
  AppstoreOutlined,
  AreaChartOutlined,
  ArrowDownOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ArrowUpOutlined,
  AudioOutlined,
  AuditOutlined,
  BackwardOutlined,
  BankOutlined,
  BarChartOutlined,
  BorderBottomOutlined,
  BorderHorizontalOutlined,
  BorderInnerOutlined,
  BorderLeftOutlined,
  BorderlessTableOutlined,
  BorderOuterOutlined,
  BorderOutlined,
  BorderRightOutlined,
  BorderTopOutlined,
  BorderVerticleOutlined,
  BranchesOutlined,
  CalendarOutlined,
  CameraOutlined,
  CaretDownOutlined,
  CaretLeftOutlined,
  CaretRightOutlined,
  CaretUpOutlined,
  CheckCircleOutlined,
  CheckOutlined,
  CheckOutlined as Check,
  ClockCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  CloseOutlined as Close,
  CloudDownloadOutlined,
  CloudOutlined,
  CloudServerOutlined,
  CloudSyncOutlined,
  CloudUploadOutlined,
  ClusterOutlined,
  CompassOutlined,
  ContactsOutlined,
  CreditCardOutlined,
  CrownOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DeleteOutlined,
  DeploymentUnitOutlined,
  DesktopOutlined,
  DisconnectOutlined,
  DislikeOutlined,
  DollarOutlined,
  DotChartOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  DownCircleOutlined,
  DownloadOutlined,
  DownOutlined,
  EditOutlined,
  EnterOutlined,
  EnvironmentOutlined,
  ExclamationCircleOutlined,
  ExclamationCircleOutlined as ExclamationCircle,
  ExclamationOutlined,
  ExpandOutlined,
  EyeOutlined,
  FallOutlined,
  FastBackwardOutlined,
  FastForwardOutlined,
  FieldTimeOutlined,
  FileExcelOutlined,
  FileImageOutlined,
  FileOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  FileTextOutlined,
  FileUnknownOutlined,
  FileWordOutlined,
  FileZipOutlined,
  FireOutlined,
  FolderAddOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  FolderViewOutlined,
  ForwardOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  FundOutlined,
  FundProjectionScreenOutlined,
  FundViewOutlined,
  GatewayOutlined,
  GiftOutlined,
  GlobalOutlined,
  HeartOutlined,
  HeatMapOutlined,
  HistoryOutlined,
  HomeOutlined,
  HourglassOutlined,
  InboxOutlined,
  InfoCircleOutlined,
  InfoCircleOutlined as InfoCircle,
  InfoOutlined,
  KeyOutlined,
  LaptopOutlined,
  LeftCircleOutlined,
  LeftOutlined,
  LikeOutlined,
  LineChartOutlined,
  LinkOutlined,
  LoadingOutlined,
  LockOutlined,
  LoginOutlined,
  LogoutOutlined,
  MailOutlined,
  MenuOutlined,
  MessageOutlined,
  MinusCircleOutlined,
  MinusOutlined,
  MinusOutlined as Minus,
  MobileOutlined,
  MoneyCollectOutlined,
  NodeCollapseOutlined,
  NodeExpandOutlined,
  NodeIndexOutlined,
  PartitionOutlined,
  PauseCircleOutlined,
  PayCircleOutlined,
  PhoneOutlined,
  PictureOutlined,
  PieChartOutlined,
  PlayCircleOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  PlusOutlined as Plus,
  PrinterOutlined,
  ProjectOutlined,
  QuestionCircleOutlined,
  QuestionCircleOutlined as QuestionCircle,
  QuestionOutlined,
  RadarChartOutlined,
  RadiusBottomleftOutlined,
  RadiusBottomrightOutlined,
  RadiusSettingOutlined,
  RadiusUpleftOutlined,
  RadiusUprightOutlined,
  ReloadOutlined,
  RightCircleOutlined,
  RightOutlined,
  RiseOutlined,
  SafetyOutlined,
  SaveOutlined as ServerOutlined,
  ScheduleOutlined,
  SearchOutlined,
  SecurityScanOutlined,
  SendOutlined,
  SettingOutlined,
  ShareAltOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  ShrinkOutlined,
  SolutionOutlined,
  SoundOutlined,
  StarOutlined,
  StepBackwardOutlined,
  StepForwardOutlined,
  StockOutlined,
  StopOutlined,
  SyncOutlined,
  TableOutlined,
  TabletOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  TrophyOutlined,
  UnlockOutlined,
  UpCircleOutlined,
  UploadOutlined,
  UpOutlined,
  UserAddOutlined,
  UserDeleteOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  UserSwitchOutlined,
  VerticalAlignBottomOutlined,
  VerticalAlignMiddleOutlined,
  VerticalAlignTopOutlined,
  VerticalLeftOutlined,
  VerticalRightOutlined,
  VideoCameraOutlined,
  WalletOutlined,
  WarningOutlined,
  WarningOutlined as Warning,
} from '@ant-design/icons';

// Типы
export type {
  AffixProps,
  AlertProps,
  AnchorProps,
  AutoCompleteProps,
  AvatarProps,
  BackTopProps,
  BadgeProps,
  BreadcrumbProps,
  ButtonProps,
  CardProps,
  CarouselProps,
  CascaderProps,
  CheckboxProps,
  CollapseProps,
  ColProps,
  DatePickerProps,
  DescriptionsProps,
  DividerProps,
  DrawerProps,
  DropdownProps,
  EmptyProps,
  FormProps,
  InputNumberProps,
  InputProps,
  LayoutProps,
  ListProps,
  MentionProps,
  MenuProps,
  ModalProps,
  PaginationProps,
  PopconfirmProps,
  PopoverProps,
  ProgressProps,
  RadioProps,
  RateProps,
  ResultProps,
  RowProps,
  SegmentedProps,
  SelectProps,
  SkeletonProps,
  SpaceProps,
  SpinProps,
  StatisticProps,
  StepsProps,
  SwitchProps,
  TableProps,
  TabsProps,
  TagProps,
  TimelineProps,
  TimePickerProps,
  TooltipProps,
  TransferProps,
  TreeProps,
  TreeSelectProps,
  TypographyProps,
  UploadProps,
} from 'antd';
// Основные компоненты
// Утилиты
export {
  Affix,
  Alert,
  Anchor,
  AutoComplete,
  Avatar,
  BackTop,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Carousel,
  Cascader,
  Checkbox,
  Col,
  Collapse,
  ConfigProvider,
  DatePicker,
  Descriptions,
  Divider,
  Drawer,
  Dropdown,
  Empty,
  Form,
  Input,
  InputNumber,
  Layout,
  List,
  Mentions,
  Menu,
  Modal,
  message,
  notification,
  Pagination,
  Popconfirm,
  Popover,
  Progress,
  Radio,
  Rate,
  Result,
  Row,
  Segmented,
  Select,
  Skeleton,
  Slider,
  Space,
  Spin,
  Statistic,
  Steps,
  Switch,
  Table,
  Tabs,
  Tag,
  Timeline,
  TimePicker,
  Tooltip,
  Transfer,
  Tree,
  TreeSelect,
  Typography,
  Upload,
} from 'antd';
